export default __webpack_public_path__ + "static/media/quickstart2-2.5f1e7779.svg";